import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

export const GeneratePDF = async (elementRef) => {
  try {
    if (!elementRef.current) {
      throw new Error("Element reference is not valid.");
    }

    const element = elementRef.current;

    // Render the entire element to a big canvas
    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      scrollY: -window.scrollY,
    });

    const imgData = canvas.toDataURL("image/png");

    // PDF setup
    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "a4",
    });

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const margin = 20;

    const imgWidth = pageWidth - margin * 2;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    const totalPDFPages = Math.ceil(imgHeight / (pageHeight - margin * 2));

    for (let i = 0; i < totalPDFPages; i++) {
      if (i > 0) pdf.addPage();

      const sourceY = i * (pageHeight - margin * 2) * (canvas.height / imgHeight);
      const pageCanvas = document.createElement("canvas");
      const pageCtx = pageCanvas.getContext("2d");

      const sliceHeight = (pageHeight - margin * 2) * (canvas.height / imgHeight);

      pageCanvas.width = canvas.width;
      pageCanvas.height = sliceHeight;

      // Draw a slice of the full canvas into a temp canvas
      pageCtx.drawImage(
        canvas,
        0, sourceY,
        canvas.width, sliceHeight,
        0, 0,
        canvas.width, sliceHeight
      );

      const pageData = pageCanvas.toDataURL("image/png");

      pdf.addImage(
        pageData,
        "PNG",
        margin,
        margin,
        imgWidth,
        pageHeight - margin * 2
      );
    }

    pdf.save("report.pdf");
    return true;
  } catch (err) {
    console.error("PDF generation failed:", err);
    return false;
  }
};